import React from "react";
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn } from "react-icons/fa";
//import rakfortLogo from "/src/rakfort.jpg"; // adjust path if in another folder

const Footer = () => {
  return (
    <footer className="text-white">
      {/* Main Footer Section */}
      <div className="bg-gradient-to-b from-[#2b0b55] to-[#0a0216] py-12 px-8 lg:px-16">
        <div className="flex flex-wrap justify-between gap-12 max-w-7xl mx-auto">
          {/* Left Section - Logo and About */}
          <div className="w-full sm:w-1/3">
            <img
              src={require("../../img/rakfort.jpg")}
              alt="Rakfort Logo"
              className="w-8 h-8 object-cover rounded"
            />
            <p className="text-sm text-gray-300 mb-4 max-w-xs">
              We’re Rakfort — a team driven by insight and connection. Our mission is simple: to bring the right people together, create meaningful collaborations, and help ideas grow into impactful results.
            </p>

            {/* <a href="tel:+11234567890" className="block text-gray-300 hover:text-white mb-2">
              (123) 456-7890
            </a> */}
            <a href="mailto:info@novistep.com" className="block text-gray-300 hover:text-white mb-4">
              info@novistep.com
            </a>

            {/* Social Icons */}
            <div className="flex space-x-4 mt-4">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="hover:text-blue-400">
                <FaFacebookF />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="hover:text-blue-400">
                <FaTwitter />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="hover:text-pink-400">
                <FaInstagram />
              </a>
              <a href="https://www.linkedin.com/company/rakfort/" target="_blank" rel="noopener noreferrer" className="hover:text-blue-500">
                <FaLinkedinIn />
              </a>
            </div>
          </div>

          {/* Product Section */}
          <div>
            <h3 className="font-semibold mb-3">Product</h3>
            <ul className="space-y-2 text-gray-300">
              <li><a href="/resume-scoring" className="hover:text-white">Resume Scoring</a></li>
              <li><a href="/interview-prep" className="hover:text-white">AI Interview Prep</a></li>
              <li><a href="/interview-simulation" className="hover:text-white">Interview Simulation</a></li>
              <li><a href="/cover-letter-generator" className="hover:text-white">Cover Ltter Generator</a></li>
              <li><a href="/job-matching" className="hover:text-white">Job Matching</a></li>
              <li><a href="/resume-builder" className="hover:text-white">Resume Builder</a></li>
            </ul>
          </div>

          {/* Explore Section */}
          <div>
            <h3 className="font-semibold mb-3">Explore</h3>
            <ul className="space-y-2 text-gray-300">
              <li><a href="/signuppricing" className="hover:text-white">Pricing</a></li>
              <li><a href="/blogs" className="hover:text-white">Blogs</a></li>
              <li><a href="/contactus" className="hover:text-white">Contact us</a></li>
            </ul>
          </div>
        </div>
      </div>

      {/* Copyright Section */}
      <div className="border-t border-gray-800 bg-[#fafafa]">
        <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-16 py-6">
          <p className="text-center text-sm text-[#3C0F6C]/70">
            © 2025 JobStep. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
